module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAUCAYAAABSx2cSAAABP0lEQVQ4jZ3Tv0pcQRTH8c9dlpAiForYSFKoTyCCJKTxCQKWksri9BbiHwI2SlCIqXcgzxB9gzRJI3mAJGAjiyiJokQECV4L74ar3Lu7+msGzvl953dmmMnyPFdWSuk1FjCDQZzgC7Yj4mvZm3XglFKGTSwWvX0c4DnGitomViIih2Zpo9UC/IH5iPh2b5pPWCom2fqfnFJ6gV84wmRE/HZPKaURfMcwJiKi3Sh6b/EE76pAiIhjrOEp5qADTxXrThVY0m7Z34GHcBER593IiPiDS4yUYfjXI7WjK2SQtVqtN/iAUaz0Ab9HGwtNd8/5sc/0cew2etrqlXWDT/AZp3WGOvgaLyNiFq+QV5nq4DO3Lw5+4u9D4EGsp5SeYQMDVaZmVbHQKvawXGfoddvT3Zq94NrUfuCuarj9w4/R4Q0/91RtGg7bDAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/views/images/user_psd.png
// module id = cvAq
// module chunks = 1